export const ADDITIONAL_INFO = {
  "GB": ["E", "F", "G"],
  "AU": ["A", "B"],
  "NZ": ["A", "B"],
  "IE": {
    "back": ["E", "F", "C", "D"],
    "front": ["E", "F", "C"]
  }
}